module.exports = __webpack_public_path__ + "static/media/_croatia.63b2b01d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_croatia.svg
// module id = 2312
// module chunks = 7